import { Pages } from "types/common";
import { generateUuid } from "./utils";
import { GTMProps, trackSubmission } from "components/common/GTMProvider";

export type AnswerData = { questionId: string; value: (string | number)[] };

const headers = {
  "correlation-id": generateUuid(),
  "x-api-key": process.env.REACT_APP_API_KEY || "",
  "Content-Type": "application/json",
};

const url = "/api/v1";
export const getUserId = async (page: Pages): Promise<number | null> => {
  try {
    const response = await fetch(`${url}/submissions`, {
      method: "POST",
      headers,
      body: JSON.stringify({ questionnaireId: `${page}-1-v2` }),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data: { id: number } = await response.json();
    return data?.id;
  } catch (error) {
    // console.error("Error getting questionnaire:", error);
    // throw error;
    return null;
  }
};

export const submitQuestionnaireAnswer = async (
  userId: number | null,
  answerData: AnswerData,
  gtmProps: GTMProps,
) => {
  try {
    const response = await fetch(`${url}/submissions/${userId}/answer`, {
      method: "POST",
      headers,
      body: JSON.stringify(answerData),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    return await response.json();
  } catch (error) {
    // console.error("Error submitting questionnaire answer:", error);
    trackSubmission({
      formId: `gcb_${userId}`,
      label: "calculate_now",
      error_name: String(error),
      section: "submitting-answers",
      component_type: "error-message",
      ...gtmProps,
    });
    // throw error;
  }
};

export const finalizeQuestionnaire = async (
  userId: number | null,
  gtmProps: GTMProps,
) => {
  try {
    const response = await fetch(`${url}/submissions/${userId}/finalize`, {
      method: "POST",
      headers,
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    if (response.status === 200) {
      return { success: true };
    }

    return await response.json();
  } catch (error) {
    // console.error("Error finalizing questionnaire:", error);
    trackSubmission({
      formId: `gcb_${userId}`,
      label: "calculate_now",
      error_name: String(error),
      section: "submitting-answers",
      component_type: "error-message",
      ...gtmProps,
    });
    // throw error;
  }
};
